import { apiRequest } from "@portal/lib/ky/utils";

export async function deleteAttachment(id: string|number) {
  await apiRequest<undefined, undefined>({
    method: "DELETE",
    url: `v1/attachments/${id}`,
  });
}